// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"Rating_ratingContainer__Tgi3y","ratingText":"Rating_ratingText__SGQWG"};